<app-loader *ngIf="isLoading"></app-loader>
<div class="contentHeight">
    <div class="tab-content adminContent" id="nav-tabContent">
        <mat-tab-group #tabGroup (selectedTabChange)="LoadData(tabGroup)" class="tabgrp" [mat-stretch-tabs]="false">
            <mat-tab label="{{ 'monitoring.activityReport' | translate }}">
                <div class="content backgroundWhiteRound">
                    <div class="beforeTable">
                        <fieldset class="noMargin row fieldset">
                            <legend class="legend">{{ 'monitoring.search' | translate }} </legend>
                            <div class="filter">
                                {{ 'monitoring.datefilter1' | translate }}
                                <mat-form-field class="datePicker">
                                    <input matInput [matDatepicker]="startdp" [min]="datemin" [max]="datenow" [formControl]="startdate" disabled>
                                    <mat-datepicker-toggle matSuffix [for]="startdp"></mat-datepicker-toggle>
                                    <mat-datepicker #startdp
                                                    disabled="false"
                                                    startView="multi-year"
                                                    (yearSelected)="chosenStartYearHandler($event)"
                                                    (monthSelected)="chosenStartMonthHandler($event, startdp)"
                                                    panelClass="example-month-picker">
                                    </mat-datepicker>
                                </mat-form-field>
                                {{ 'monitoring.datefilter2' | translate }}
                                <mat-form-field class="datePicker">
                                    <input matInput [matDatepicker]="enddp" [min]="datemin" [max]="datenow" [formControl]="enddate" disabled>
                                    <mat-datepicker-toggle matSuffix [for]="enddp"></mat-datepicker-toggle>
                                    <mat-datepicker #enddp
                                                    disabled="false"
                                                    startView="multi-year"
                                                    (yearSelected)="chosenEndYearHandler($event)"
                                                    (monthSelected)="chosenEndMonthHandler($event, enddp)"
                                                    panelClass="example-month-picker">
                                    </mat-datepicker>
                                </mat-form-field>

                                <button class="search" (click)="changeFilter()">{{ 'accountChoice.rechercher' | translate }}</button>
                            </div>
                        </fieldset>
                        <div class="divAjoutRapport" *ngIf="Utils.isAdminLacour(role)">
                            <button class="btn btnAjoutRapport" (click)="openModalAddFile()"><i aria-hidden="true" class="fas fa-plus fa-1x" style="color:green"></i> Ajouter un Rapport</button>
                        </div>
                    </div>
                    <div class="tab-pane noOverflow fade show active lstRapport">
                        <table mat-table class="table lstdossier bg-white table-hover" matSort [dataSource]="breakdownFileSource" (matSortChange)="sortFile($event,'1')">
                            <ng-container matColumnDef="nameFile">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'monitoring.rapport' | translate }}</th>
                                <td mat-cell *matCellDef="let res" class="rapport">{{ res.breakdownName }}</td>
                            </ng-container>
                            <ng-container matColumnDef="dateFile">
                                <th mat-header-cell *matHeaderCellDef [ngClass]="'customWidthDateTable'" mat-sort-header>{{ 'monitoring.date' | translate }}</th>
                                <td mat-cell *matCellDef="let res" [ngClass]="'customWidthDateTable'">{{ res.fileDate | date:"MM/yyyy" }}</td>
                            </ng-container>
                            <ng-container matColumnDef="dateFileEdit">
                                <th mat-header-cell *matHeaderCellDef [ngClass]="'customWidthDateTable'" mat-sort-header>Date</th>
                                <td mat-cell *matCellDef="let res; let i = index;" [ngClass]="'customWidthDateTable'" style="">
                                    <mat-form-field class="datePicker">
                                        <input matInput [matDatepicker]="yeardp_i" [min]="datemin" [max]="datenow" [(ngModel)]="res.fileDate" disabled />
                                        <mat-datepicker-toggle matSuffix [for]="yeardp_i"></mat-datepicker-toggle>
                                        <mat-datepicker #yeardp_i
                                                        disabled="false"
                                                        startView="multi-year"
                                                        (yearSelected)="chosenChangeYearHandler($event, res, i)"
                                                        (monthSelected)="chosenChangeMonthHandler($event, yeardp_i, res, i)"
                                                        panelClass="example-month-picker">
                                        </mat-datepicker>
                                    </mat-form-field>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="readFile">
                                <th mat-header-cell *matHeaderCellDef [ngClass]="'customWidthButtonTable'">{{ 'monitoring.see' | translate }}</th>
                                <td mat-cell *matCellDef="let res" [ngClass]="'customWidthButtonTable'">
                                    <i aria-hidden="true" class="fas fa-search fa-1x btnLook pointer steelblue" (click)="openFile(res)" matTooltip="{{ 'monitoring.see' | translate }}"></i>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="update">
                                <th mat-header-cell *matHeaderCellDef [ngClass]="'customWidthButtonTable'">Editer</th>
                                <td mat-cell *matCellDef="let res" [ngClass]="'customWidthButtonTable'">
                                    <i aria-hidden="true" class="fad fa-edit fa-1x pointer steelblue" (click)="openModalEditFile(res)" matTooltip="Editer le rapport"></i>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="delete">
                                <th mat-header-cell *matHeaderCellDef [ngClass]="'customWidthButtonTable'">Supprimer</th>
                                <td mat-cell *matCellDef="let res" [ngClass]="'customWidthButtonTable'">
                                    <i aria-hidden="true" class="fad fa-trash fa-1x pointer" style=" --fa-primary-color: #e0003c ; --fa-secondary-color: #da2917ed;" (click)="openModalDeleteFile(res)" matTooltip="Supprimer le rapport"></i>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        </table>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="{{'monitoring.version'|translate}}">
                <label> date de traitement : {{this.dateImportationVersion | date:'dd/MM/yyyy HH:mm'}}</label>
                <mat-tab-group #tabGroupConnect class="tabgrp" (selectedTabChange)="changeVersion(tabGroupConnect)" [mat-stretch-tabs]="false">
                    <mat-tab label="Stats Balances connectées">
                        <div class="backgroundWhiteRound contentMAJ">

                            <!--<button (click)="Export()" class="export">Export Excel</button>-->

                            <div (click)="OpenMAJLocal()"><label class="titre">{{'monitoring.majLocale'|translate}}</label><i aria-hidden="true" *ngIf="localOpen" class="fas fa-chevron-down"></i><i aria-hidden="true" *ngIf="!localOpen" class="fas fa-chevron-up"></i></div>
                            <div class="overflow-table" *ngIf="bddLocal && localOpen">
                                <table mat-table [dataSource]="BddLocalSource">
                                    <ng-container matColumnDef="country">
                                        <th mat-header-cell *matHeaderCellDef class="country">{{'scaleform.pays'|translate}}</th>
                                        <td mat-cell *matCellDef="let res" class="country">
                                            <span>{{res.country}}</span>
                                        </td>
                                        <td mat-footer-cell class="country" *matFooterCellDef> {{'manageaccount.total'|translate}} </td>
                                    </ng-container>
                                    <div *ngFor="let column of versionsLocal">
                                        <ng-container matColumnDef="{{column}}">
                                            <th mat-header-cell *matHeaderCellDef>{{column}}</th>
                                            <td mat-cell *matCellDef="let res">
                                                <span>{{GetNbLocal(res.country,column)}}</span>
                                            </td>
                                            <td mat-footer-cell class="foot" *matFooterCellDef> {{GetTotalLocal(column)}} </td>
                                        </ng-container>
                                    </div>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsBDDLocal; sticky:true"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumnsBDDLocal"></tr>
                                    <tr mat-footer-row *matFooterRowDef="displayedColumnsBDDLocal; sticky: true"></tr>
                                </table>
                            </div>
                            <br />
                            <div (click)="OpenMAJInternet()"><label class="titre">{{'monitoring.majInternet'|translate}}</label><i aria-hidden="true" *ngIf="internetOpen" class="fas fa-chevron-down"></i><i aria-hidden="true" *ngIf="!internetOpen" class="fas fa-chevron-up"></i></div>
                            <div class="overflow-table" *ngIf="bddInternet && internetOpen">
                                <table mat-table [dataSource]="BddLocalSource">
                                    <ng-container matColumnDef="country">
                                        <th mat-header-cell *matHeaderCellDef class="country">{{'scaleform.pays'|translate}}</th>
                                        <td mat-cell *matCellDef="let res" class="country">
                                            <span>{{res.country}}</span>
                                        </td>
                                        <td mat-footer-cell class="country" *matFooterCellDef> {{'manageaccount.total'|translate}} </td>
                                    </ng-container>
                                    <div *ngFor="let column of versionsInternet">
                                        <ng-container matColumnDef="{{column}}">
                                            <th mat-header-cell *matHeaderCellDef>{{column}}</th>
                                            <td mat-cell *matCellDef="let res">
                                                <span>{{GetNbInternet(res.country,column)}}</span>
                                            </td>
                                            <td mat-footer-cell class="foot" *matFooterCellDef> {{GetTotalInternet(column)}} </td>
                                        </ng-container>
                                    </div>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsBDDInternet; sticky:true"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumnsBDDInternet"></tr>
                                    <tr mat-footer-row *matFooterRowDef="displayedColumnsBDDInternet; sticky: true"></tr>
                                </table>
                            </div>
                            <br />
                            <div (click)="OpenMAJSpectro()"><label class="titre">{{'monitoring.majSpectro'|translate}}</label><i aria-hidden="true" *ngIf="spectroOpen" class="fas fa-chevron-down"></i><i aria-hidden="true" *ngIf="!spectroOpen" class="fas fa-chevron-up"></i></div>
                            <div class="overflow-table" *ngIf="spectro && spectroOpen">
                                <table mat-table [dataSource]="BddLocalSource" class="spectro">
                                    <ng-container matColumnDef="country">
                                        <th mat-header-cell *matHeaderCellDef class="country">{{'scaleform.pays'|translate}}</th>
                                        <td mat-cell *matCellDef="let res" class="country">
                                            <span>{{res.country}}</span>
                                        </td>
                                        <td mat-footer-cell class="country" *matFooterCellDef> {{'manageaccount.total'|translate}} </td>
                                    </ng-container>
                                    <div *ngFor="let column of versionsSpectro">
                                        <ng-container matColumnDef="{{column}}">
                                            <th mat-header-cell *matHeaderCellDef>{{column.split(" ")[0]}} <br /> {{column.split(" ")[1]}} </th>
                                            <td mat-cell *matCellDef="let res">
                                                <span>{{GetNbSpectro(res.country,column)}}</span>
                                            </td>
                                            <td mat-footer-cell class="foot" *matFooterCellDef> {{GetTotalSpectro(column)}} </td>
                                        </ng-container>
                                    </div>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsSpectro; sticky:true"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumnsSpectro"></tr>
                                    <tr mat-footer-row *matFooterRowDef="displayedColumnsSpectro; sticky: true"></tr>
                                </table>

                                <br />
                                <!--<div class="winIxell" *ngIf="spectro && spectroOpen">
                                  <label>WinIxell</label>
                                </div>
                                <table mat-table [dataSource]="BddLocalSource" *ngIf="spectro && spectroOpen" class="winIxell">
                                  <ng-container matColumnDef="country">
                                    <th mat-header-cell *matHeaderCellDef> {'scaleform.pays'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="country">
                                      <span> {res.country}}</span>
                                    </td>
                                    <td mat-footer-cell class="country" *matFooterCellDef> {'manageaccount.total'|translate}} </td>
                                  </ng-container>
                                  <div *ngFor="let column of versionsSpectroWinIxell">
                                    <ng-container matColumnDef=" {column}}">
                                      <th mat-header-cell *matHeaderCellDef> {column}}</th>
                                      <td mat-cell *matCellDef="let res">
                                        <span> {GetNbSpectroWinIxell(res.country,column)}}</span>
                                      </td>
                                      <td mat-footer-cell class="foot" *matFooterCellDef> {GetTotalSpectroWinIxell(column)}} </td>
                                    </ng-container>
                                  </div>
                                  <tr mat-header-row *matHeaderRowDef="displayedColumnsSpectroWinIxell; sticky:true"></tr>
                                  <tr mat-row *matRowDef="let row; columns: displayedColumnsSpectroWinIxell"></tr>
                                  <tr mat-footer-row *matFooterRowDef="displayedColumnsSpectroWinIxell; sticky: true"></tr>
                                </table>-->
                            </div>
                        </div>
                    </mat-tab>

                    <mat-tab label="Balances connectées">
                        <div class="disconnected">
                            <table mat-table matSort [dataSource]="ScalesConnectedSource" (matSortChange)="sortVersionConnected($event,'1')">

                                <ng-container matColumnDef="Unisite">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Unisite</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.unisite}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Nom_RS">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.raisonsociale'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.nom_ou_RS}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Adresse1">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.adresse'|translate}}1</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.adresse1}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Adresse2">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.adresse'|translate}}2</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.adresse2}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Code Postal">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.codepostal'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.code_Postal}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Ville">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.ville'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.ville}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Pays">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.pays'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.pays}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Numserie">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'monitoring.serialNumber'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.sN_Balance}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Dateinstallation">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date installation</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.date_installation | date: 'dd/MM/yyyy'}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Fincontrat">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Fin de contrat</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span *ngIf="res.fin_de_contrat != '0000-00-00'">{{res.fin_de_contrat | date: 'dd/MM/yyyy'}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Programme">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Programme</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.programme}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Bdd Locale">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>BDD Locale</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.bddlocale}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Bdd Internet">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>BDD Internet</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.bddinternet}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Spectro">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Spectro</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.spectro}}</span>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsDisconnectedScales; sticky:true"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsDisconnectedScales"></tr>
                            </table>
                        </div>
                    </mat-tab>

                    <mat-tab label="Balances non connectées temporairement">
                        <div class="disconnected">
                            <table mat-table [dataSource]="ScalesDisconnectedTempSource" matSort (matSortChange)="sortVersionDisconnectedTemp($event,'1')">

                                <ng-container matColumnDef="Unisite">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Unisite</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.unisite}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Nom_RS">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.raisonsociale'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.nom_ou_RS}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Adresse1">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.adresse'|translate}}1</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.adresse1}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Adresse2">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.adresse'|translate}}2</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.adresse2}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Code Postal">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.codepostal'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.code_Postal}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Ville">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.ville'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.ville}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Pays">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.pays'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.pays}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Numserie">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'monitoring.serialNumber'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.sN_Balance}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Dateinstallation">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date installation</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.date_installation | date: 'dd/MM/yyyy'}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Fincontrat">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Fin de contrat</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span *ngIf="res.fin_de_contrat != '0000-00-00'">{{res.fin_de_contrat | date: 'dd/MM/yyyy'}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Programme">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Programme</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.programme}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Bdd Locale">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>BDD Locale</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.bddlocale}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Bdd Internet">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>BDD nternet</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.bddinternet}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Spectro">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Spectro</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.spectro}}</span>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumnsDisconnectedScales; sticky:true"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsDisconnectedScales"></tr>
                            </table>
                        </div>
                    </mat-tab>

                    <mat-tab label="Balances non connectées définitivement">
                        <div class="disconnected">
                            <table mat-table [dataSource]="ScalesDisconnectedSource" matSort (matSortChange)="sortVersionDisconnected($event,'1')">

                                <ng-container matColumnDef="Unisite">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Unisite</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.unisite}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Nom_RS">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.raisonsociale'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.nom_ou_RS}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Adresse1">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.adresse'|translate}}1</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.adresse1}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Adresse2">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.adresse'|translate}}2</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.adresse2}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Code Postal">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.codepostal'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.code_Postal}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Ville">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.ville'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.ville}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Pays">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.pays'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.pays}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Numserie">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'monitoring.serialNumber'|translate}}</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.sN_Balance}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Dateinstallation">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date installation</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.date_installation | date: 'dd/MM/yyyy'}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Fincontrat">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Fin de contrat</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span *ngIf="res.fin_de_contrat != '0000-00-00'">{{res.fin_de_contrat | date: 'dd/MM/yyyy'}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Programme">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Programme</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.programme}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Bdd Locale">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>BDD Locale</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.bddlocale}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Bdd Internet">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>BDD nternet</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.bddinternet}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Spectro">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Spectro</th>
                                    <td mat-cell *matCellDef="let res" class="version">
                                        <span>{{res.spectro}}</span>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumnsDisconnectedScales; sticky:true"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsDisconnectedScales"></tr>
                            </table>
                        </div>
                    </mat-tab>
                    <!--<mat-tab label="Balances hors contrat">
                      <div class="horsContrat">
                        <table mat-table [dataSource]="ScalesHorsContratSource" matSort (matSortChange)="sortVersionHorsContrat($event,'1')">

                          <ng-container matColumnDef="Nom_RS">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.raisonsociale'|translate}}</th>
                            <td mat-cell *matCellDef="let res" class="version">
                              <span>{{res.nom_ou_RS}}</span>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="Adresse1">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.adresse'|translate}}1</th>
                            <td mat-cell *matCellDef="let res" class="version">
                              <span>{{res.adresse1}}</span>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="Adresse2">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.adresse'|translate}}2</th>
                            <td mat-cell *matCellDef="let res" class="version">
                              <span>{{res.adresse2}}</span>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="Code Postal">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.codepostal'|translate}}</th>
                            <td mat-cell *matCellDef="let res" class="version">
                              <span>{{res.code_Postal}}</span>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="Ville">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.ville'|translate}}</th>
                            <td mat-cell *matCellDef="let res" class="version">
                              <span>{{res.ville}}</span>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="Pays">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.pays'|translate}}</th>
                            <td mat-cell *matCellDef="let res" class="version">
                              <span>{{res.pays}}</span>
                            </td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="displayedColumnsHorsContratScales; sticky:true"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumnsHorsContratScales"></tr>
                        </table>
                      </div>
                    </mat-tab>-->
                    <mat-tab label="Export Excel" class="exportVersion">

                    </mat-tab>
                </mat-tab-group>
            </mat-tab>
            <mat-tab label="{{'monitoring.assistBalance'|translate}}">
                <label> date de traitement : {{this.dateImportationAssistance | date:'dd/MM/yyyy HH:mm'}}</label>
                <div class="backgroundWhiteRound contentMAJAssist">
                    <form [formGroup]="Form" class="formAssistance">
                        <mat-form-field class="country">
                            <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                            <mat-select formControlName="Country" required>
                                <mat-option *ngFor="let country of countries" value="{{country.fr}}"> {{country.txt|translate}} </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="postalCode">
                            <mat-label>{{'scaleform.codepostal'|translate}}</mat-label>
                            <input matInput formControlName="PostalCode" autocomplete="off">
                        </mat-form-field>

                        <mat-form-field class="socialReason">
                            <mat-label>{{'scaleform.raisonsociale'|translate}}</mat-label>
                            <input matInput formControlName="SocialReason">
                        </mat-form-field>

                        <mat-form-field class="Ctc">
                            <mat-label>{{'manageaccount.ctcName'|translate}}</mat-label>
                            <input matInput formControlName="CTC">
                        </mat-form-field>{{ 'monitoring.datefilter3' | translate }}<mat-form-field class="datePickerAssistance">
                            <input matInput [matDatepicker]="DateStart" formControlName="DateStart">
                            <mat-datepicker-toggle matSuffix [for]="DateStart"></mat-datepicker-toggle>
                            <mat-datepicker #DateStart>
                            </mat-datepicker>
                        </mat-form-field>{{ 'monitoring.datefilter2' | translate }}<mat-form-field class="datePickerAssistance">
                            <input matInput [matDatepicker]="DateEnd" formControlName="DateEnd">
                            <mat-datepicker-toggle matSuffix [for]="DateEnd"></mat-datepicker-toggle>
                            <mat-datepicker #DateEnd></mat-datepicker>
                        </mat-form-field>

                        <button class="search" (click)="filtreAssistance()">{{ 'accountChoice.rechercher' | translate }}</button>
                        <button class="export" (click)="ExportAssistance()">Export Excel</button>
                    </form>
                    <div class="assistanceTab">
                        <table mat-table [dataSource]="AssistanceSource" matSort class="assistanceTab" (matSortChange)="sortAssist($event,'1')">
                            <ng-container matColumnDef="RS">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.raisonsociale'|translate}}</th>
                                <td mat-cell *matCellDef="let res" (click)="openAssistance(res)" class="assistance">
                                    <span>{{res.raison_sociale}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Adresse1">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.adresse'|translate}}1</th>
                                <td mat-cell *matCellDef="let res" (click)="openAssistance(res)" class="assistance">
                                    <span>{{res.adresse1}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Adresse2">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.adresse'|translate}}2</th>
                                <td mat-cell *matCellDef="let res" (click)="openAssistance(res)" class="assistance">
                                    <span>{{res.adresse2}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Code Postale">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.codepostal'|translate}}</th>
                                <td mat-cell *matCellDef="let res" (click)="openAssistance(res)" class="assistance">
                                    <span>{{res.code_Postal}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Ville">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.ville'|translate}}</th>
                                <td mat-cell *matCellDef="let res" (click)="openAssistance(res)" class="assistance">
                                    <span>{{res.ville}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Pays">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.pays'|translate}}</th>
                                <td mat-cell *matCellDef="let res" (click)="openAssistance(res)" class="assistance">
                                    <span>{{res.pays}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="CTC">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>CTC</th>
                                <td mat-cell *matCellDef="let res" (click)="openAssistance(res)" class="assistance">
                                    <span>{{res.ctc}}</span>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsAssistance; sticky:true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsAssistance"></tr>
                        </table>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Indicateurs Assistance">
                <div class="backgroundWhiteRound">
                    <div class="info">
                        <label>Statistique pour la période du {{statsDateDeb}} au {{statsDateFin}}</label><br />
                        <label>{{'monitoring.appelMois'|translate}} : {{nbDossier| number : '1.2-2'}}</label><br />
                        <label>{{'monitoring.appelMoy'|translate}} : {{dureeAppelMoy}}</label>
                        <div>
                            <label>{{'monitoring.tempsCharge'|translate}} : </label>
                            <table class="temps">
                                <caption></caption>
                                <thead>
                                    <tr>
                                        <th scope="col" class="head center">< 30 min</th>
                                        <th scope="col" class="head center">< 1h</th>
                                        <th scope="col" class="head center">< 2h</th>
                                        <th scope="col" class="head center">2h et plus</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="center">{{min30| number : '1.2-2'}} %</td>
                                        <td class="center">{{min1 | number : '1.2-2'}} %</td>
                                        <td class="center">{{min2 | number : '1.2-2'}} %</td>
                                        <td class="center">{{plus2| number : '1.2-2'}} %</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
<div *ngIf="displayModalAddFile || displayModalEditFile || displayModalDeleteFile" id="ModalBackdrop">
</div>
<div *ngIf="displayModalAddFile" id="ModalAddFile" class="modal">
    <div class="modal-content">
        <div class="headerModal">
            <h3 class="leftFlex">Ajout d'un Rapport d'activité</h3>
            <span class="close pointer" (click)="closeModalAddFile()">  <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
        </div>
        <div>
            <div class="row">
                <div class="offset-2 col-10">
                    Date
                    <mat-form-field class="datePicker">
                        <input matInput [matDatepicker]="dp" [min]="datemin" [max]="datenow" [formControl]="date" disabled>
                        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker #dp
                                        disabled="false"
                                        startView="multi-year"
                                        (yearSelected)="chosenYearHandler($event)"
                                        (monthSelected)="chosenMonthHandler($event, dp)"
                                        panelClass="example-month-picker">
                        </mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="offset-2 col-10 margin">
                    Rapport
                    <input #file type="file" accept=".pdf" class="element" (change)="onFileChanged($event, file)" />
                </div>
                <div class="offset-2 col-10">
                    <input style="width:90%;" [(ngModel)]="BreakdownFile.breakdownName" />
                </div>
            </div>
            <div class="center">
                <button class="btn btn-secondary btnValid button" type="button" label="Annuler" name="Annuler" value="Annuler" (click)="closeModalAddFile()">Annuler</button>
                <button class="btn btn-secondary btnValid button" type="submit" label="Enregistrer" [disabled]="selectedFile == null " (click)="addFile()">Enregistrer</button>
            </div>
        </div>
    </div>
</div>
<div *ngIf="displayModalEditFile" id="ModalEditFile" class="modal">
    <div class="modal-content">
        <div class="headerModal">
            <h3 class="leftFlex">Edition d'un Rapport d'activité</h3>
            <span class="close pointer" (click)="closeModalEditFile()">  <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
        </div>
        <div>
            <div class="row">
                <div class="offset-1 col-10">
                    <div class="">
                        <input style="width:90%;" [(ngModel)]="BreakdownFile.breakdownName" />
                    </div>
                    Nouvelle date
                    <mat-form-field class="datePicker">
                        <input matInput [min]="datemin" [max]="datenow" [matDatepicker]="dpEdit" [(ngModel)]="BreakdownFile.fileDate" disabled>
                        <mat-datepicker-toggle matSuffix [for]="dpEdit"></mat-datepicker-toggle>
                        <mat-datepicker #dpEdit
                                        disabled="false"
                                        startView="multi-year"
                                        (yearSelected)="chosenYearEditHandler($event)"
                                        (monthSelected)="chosenMonthEditHandler($event, dpEdit)"
                                        panelClass="example-month-picker">
                        </mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="center">
                <button class="btn btn-secondary btnValid button" type="button" name="Annuler" value="Annuler" (click)="closeModalEditFile()">Annuler</button>
                <button class="btn btn-secondary btnValid button" type="submit" (click)="editFile()">Enregistrer</button>
            </div>
        </div>
    </div>
</div>
<div *ngIf="displayModalDeleteFile" id="ModalDeleteFile" class="modal">
    <div class="modal-content">
        <div class="headerModal">
            <h3 class="leftFlex">Suppression d'un Rapport d'activité</h3>
            <span class="close pointer" (click)="closeModalDeleteFile()">  <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
        </div>
        <div>
            <div class="">
                Êtes-vous sûr de vouloir supprimer le fichier {{BreakdownFile.breakdownName}} ?
            </div>

            <div class="center">
                <button class="btn btn-secondary btnValid button" type="button" (click)="closeModalDeleteFile()">Non</button>
                <button class="btn btn-secondary btnValid button" type="button" (click)="deleteFile()">Oui</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="assistanceDos" id="ModalAssitance" class="modal">
    <div class="modal-content">
        <div class="headerModal">
            <h3 class="leftFlex">Liste des dossiers d'assistance pour {{currentRS}}</h3>
            <span class="close pointer" (click)="closeInfo()">  <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
        </div>
        <div class="modal-assist">
            <div class="assistanceData">
                <table mat-table [dataSource]="AssistanceDosSource">
                    <ng-container matColumnDef="N°Dossier">
                        <th mat-header-cell *matHeaderCellDef class="matHead">{{'monitoring.numDossier'|translate}}</th>
                        <td mat-cell *matCellDef="let res" (click)="SelectDosAssistance(res)" class="assistance" [class.lightGrey]="currentAssistance && currentAssistance.numDossier == res.numDossier">
                            <span>{{res.numDossier}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="creation">
                        <th mat-header-cell *matHeaderCellDef class="matHead">{{'monitoring.creation'|translate}}</th>
                        <td mat-cell *matCellDef="let res" (click)="SelectDosAssistance(res)" class="assistance" [class.lightGrey]="currentAssistance && currentAssistance.numDossier == res.numDossier">
                            <span>{{res.message_Date_creation | date:'dd/MM/yyyy HH:mm:ss'}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="RS">
                        <th mat-header-cell *matHeaderCellDef class="matHead">{{'scaleform.raisonsociale'|translate}}</th>
                        <td mat-cell *matCellDef="let res" (click)="SelectDosAssistance(res)" class="assistance" [class.lightGrey]="currentAssistance && currentAssistance.numDossier == res.numDossier">
                            <span>{{res.raison_sociale}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Adresse1">
                        <th mat-header-cell *matHeaderCellDef class="matHead">{{'scaleform.adresse'|translate}}1</th>
                        <td mat-cell *matCellDef="let res" (click)="SelectDosAssistance(res)" class="assistance" [class.lightGrey]="currentAssistance && currentAssistance.numDossier == res.numDossier">
                            <span>{{res.adresse1}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Adresse2">
                        <th mat-header-cell *matHeaderCellDef class="matHead">{{'scaleform.adresse'|translate}}2</th>
                        <td mat-cell *matCellDef="let res" (click)="SelectDosAssistance(res)" class="assistance" [class.lightGrey]="currentAssistance && currentAssistance.numDossier == res.numDossier">
                            <span>{{res.adresse2}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Code Postale">
                        <th mat-header-cell *matHeaderCellDef class="matHead">{{'scaleform.codepostal'|translate}}</th>
                        <td mat-cell *matCellDef="let res" (click)="SelectDosAssistance(res)" class="center" [class.lightGrey]="currentAssistance && currentAssistance.numDossier == res.numDossier">
                            <span>{{res.code_Postal}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Ville">
                        <th mat-header-cell *matHeaderCellDef class="matHead">{{'scaleform.ville'|translate}}</th>
                        <td mat-cell *matCellDef="let res" (click)="SelectDosAssistance(res)" class="center" [class.lightGrey]="currentAssistance && currentAssistance.numDossier == res.numDossier">
                            <span>{{res.ville}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Pays">
                        <th mat-header-cell *matHeaderCellDef class="matHead">{{'scaleform.pays'|translate}}</th>
                        <td mat-cell *matCellDef="let res" (click)="SelectDosAssistance(res)" class="center" [class.lightGrey]="currentAssistance && currentAssistance.numDossier == res.numDossier">
                            <span>{{res.pays}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="CTC">
                        <th mat-header-cell *matHeaderCellDef class="matHead">CTC</th>
                        <td mat-cell *matCellDef="let res" (click)="SelectDosAssistance(res)" class="center" [class.lightGrey]="currentAssistance && currentAssistance.numDossier == res.numDossier">
                            <span>{{res.ctc}}</span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsAssistanceDos;"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsAssistanceDos"></tr>
                </table>
                <div *ngIf="currentAssistance">
                    <table mat-table [dataSource]="AssistanceSource" class="tabinfo">
                        <ng-container matColumnDef="cloture">
                            <th mat-header-cell *matHeaderCellDef class="matHead">{{'monitoring.cloture'|translate}}</th>
                            <td mat-cell *matCellDef="let info" class="center">
                                <div *ngIf="info.date_de_cloture != '0000-00-00T00:00:00' && info.date_de_cloture != '0000-00-00T00:00:00.000'"><span>{{info.date_de_cloture | date:'dd/MM/yyyy'}}</span></div>
                            </td>
                        </ng-container>

                        <!--<ng-container matColumnDef="temps">
                          <th mat-header-cell *matHeaderCellDef class="matHead">{{'monitoring.tempsCharge'|translate}}</th>
                          <td mat-cell *matCellDef="let info" class="center">
                            <span>{{info.tempsPriseEnchargeCalc}}</span>
                          </td>
                        </ng-container>-->

                        <ng-container matColumnDef="qualif">
                            er
                            <th mat-header-cell *matHeaderCellDef class="matHead">{{'monitoring.qualif'|translate}}</th>
                            <td mat-cell *matCellDef="let info" class="center">
                                <span>{{info.qualification_2}}&nbsp;/&nbsp;{{info.qualification_3}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="S/N balance">
                            <th mat-header-cell *matHeaderCellDef class="matHead">{{'monitoring.serialNumber'|translate}}</th>
                            <td mat-cell *matCellDef="let info" class="center">
                                <span>{{info.materiel_SN}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="question">
                            <th mat-header-cell *matHeaderCellDef class="matHead">Question</th>
                            <td mat-cell *matCellDef="let info" class="center linebreak">
                                <span *ngIf="info.appel">{{info.appel[info.appel.length-1].question}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="dureeTotal">
                            <th mat-header-cell *matHeaderCellDef class="rep matHead">Durée totale des appels</th>
                            <td mat-cell *matCellDef="let info" class="center linebreak">
                                <span>{{currentAssistanceTotalCallTimeCalc}}</span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsAssistancePlus;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsAssistancePlus"></tr>
                    </table>
                </div>
            </div>
            <div *ngIf="currentAssistance">
                <br /> <strong> Appels:</strong>
                <div class="assistanceInfo">
                    <table mat-table [dataSource]="AssistanceInfoSource" class="tabinfo">
                        <ng-container matColumnDef="creation">
                            <th mat-header-cell *matHeaderCellDef class="creation matHead">{{'monitoring.creation'|translate}}</th>
                            <td mat-cell *matCellDef="let info" class="center creation">
                                <i aria-hidden="true" class="fas fa-phone-alt"></i>
                                <i aria-hidden="true" *ngIf="info.sensAppel == 'S'" class="fas fa-arrow-alt-right"></i>
                                <i aria-hidden="true" *ngIf="info.sensAppel != 'S'" class="fas fa-arrow-alt-left"></i>
                                <span>
                                    {{info.appel_Date_Creation | date:'dd/MM/yyyy'}}<br />{{info.heuredebutAppel}}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="priseEnCharge">
                            <th mat-header-cell *matHeaderCellDef class="creation matHead">Temps de prise en charge</th>
                            <td mat-cell *matCellDef="let info" class="center creation">
                                <span>{{info.tempsPriseEncharge}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="duree">
                            <th mat-header-cell *matHeaderCellDef class="duree matHead">
                                {{'monitoring.duree'|translate}}
                            </th>
                            <td mat-cell *matCellDef="let info" class="center duree">
                                <span>{{info.dureeAppelCalc}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="reponse">
                            <th mat-header-cell *matHeaderCellDef class="rep matHead">Réponse</th>
                            <td mat-cell *matCellDef="let info" class="center linebreak">
                                <span>{{info.reponse}}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="interlocuteur">
                            <th mat-header-cell *matHeaderCellDef class=" inter matHead">interlocuteur</th>
                            <td mat-cell *matCellDef="let info" class="center linebreak inter">
                                <span>{{info.interlocuteur}}</span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumnAssistanceInfo; sticky:true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnAssistanceInfo"></tr>
                    </table>

                    <div *ngIf="currentAssistance.balance_echange" class="infocomp">
                        <div class="echangeTitre">Echange balance</div><br />
                        <div class="infoCompLine">
                            <div class="lab">{{'monitoring.dateExp'|translate}} :</div><label>{{currentAssistance.echange_Date_Expedition | date:'dd/MM/yyyy'}}</label>
                        </div>
                        <div class="infoCompLine">
                            <div class="lab">{{'monitoring.startDate'|translate}} :</div>
                            <div *ngIf="currentAssistance.echange_Date_Mise_en_route != '0000-00-00T00:00:00' && currentAssistance.echange_Date_Mise_en_route != '0000-00-00T00:00:00.000'"><label>{{currentAssistance.echange_Date_Mise_en_route | date:'dd/MM/yyyy'}}</label></div>
                        </div>
                        <div class="infoCompLine">
                            <div class="lab" *ngIf="currentAssistance.echange_Duree">{{'monitoring.duree'|translate}} :</div><div *ngIf="currentAssistance.echange_Duree"><label>{{currentAssistance.echange_Duree}}</label><label>&nbsp;{{'monitoring.jours'|translate}}</label></div>
                        </div>
                        <div class="infoCompLine">
                            <div class="lab">{{'monitoring.diag1'|translate}}&nbsp;:</div><span class="linebreak">{{currentAssistance.echange_Diagnostic_SAV1}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
